export default "__VITE_ASSET__X_OntW9r__"